<template>
  <div class="desk-frame contact-page">
    <div
      class="head_row_calander bg--white flex flex--content--between no_mobile"
    >
      <h1 class="title title--40 no-marge tx--blue2">ההודעות שלי</h1>
      <a
        href="https://api.whatsapp.com/send/?phone=97299594809&text=שלום&type=phone_number&app_absent=0"
        target="_blank"
        class="bt_blue"
        style="padding-right: 22px;"
      >
        מוקד Fixer
      </a>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <div class="msg-page calandr_main only-surg calendar_desktop relative">
      <div class="tb-top-search flex m-block">
        <!-- filters desktop -->
        <div class="row-tb-filters flex items-start no_mobile">
          <h2 class="title flex items-start">
            <img src="/assets/img/svg/filters.svg" alt="" />
            מסנן:
          </h2>
          <div class="tb-filters-in is--fit flex">
            <div class="tb-filters-in flex">
              <span
                v-for="msgType in msgsType"
                :key="msgType.value"
                class="tb-filter pointer"
                :class="{ active: selectedMsgType.includes(msgType.value) }"
                @click="toggleSelectedType(msgType.value)"
              >
                {{ msgType.text }}
              </span>
            </div>
            <a
              href="javascript:void(0)"
              v-show="selectedMsgType.length < defaultSelectedMsgType.length"
              class="clear-filters flex"
              style="margin-right:6px;"
              @click="selectedMsgType = [...defaultSelectedMsgType]"
            >
              <img src="/assets/img/svg/trash.svg" alt="" />
              ניקוי סינונים
            </a>
          </div>
        </div>
        <div class="text--20 tx-blue mb-1 mobile_only">טווח תאריכים:</div>
        <DateRangePicker
          v-model="dateRanges"
          :locale-data="locale"
          :linked-calendars="false"
          opens="right"
          @update="updateDatesFromCalendar"
        />
      </div>

      <!-- filters mobile -->
      <div class="msg-mm-filters flex mobile_only">
        <button class="m-open-filters flex" @click="openFiltersPopup">
          <img src="/assets/img/svg/filters.svg" alt="" />
          מסנן
        </button>
        <a
          href="javascript:void(0)"
          v-show="selectedMsgType.length < defaultSelectedMsgType.length"
          class="clear-filters flex"
          @click="selectedMsgType = [...defaultSelectedMsgType]"
        >
          <img src="/assets/img/svg/trash.svg" alt="" />
          ניקוי סינונים
        </a>
      </div>

      <div class="all-my-msg" v-if="displayedMsgs && displayedMsgs.length">
        <MsgItem v-for="(msg, i) in displayedMsgs" :key="i" :msg="msg" />
      </div>
      <div v-else class="my-msg-empty center">
        <img src="/assets/img/svg/mail-empty.svg" />
        אין לך הודעות
      </div>

      <TablePagination
        :current="currentPage + 1"
        :total="numberOfPages"
        @setPage="setPage"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import DateRangePicker from "vue2-daterange-picker";
import { LOCALE } from "../utilities/tables-config";
import TablePagination from "@/components/Table/TablePagination";
import MsgItem from "@/components/Messages/Item";
import TableFiltersMobilePopup from "@/components/Popups/TableFiltersMobilePopup";

export default {
  name: "Messages",
  components: {
    DashboardHeader,
    Menu,
    MenuDesktop,
    DateRangePicker,
    TablePagination,
    MsgItem
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE", "activeUser"]),
    messages() {
      if (
        !this.activeUser ||
        !this.activeUser.doctor_messages ||
        !this.activeUser.doctor_messages.length
      )
        return [];

      let tmp = this.activeUser.doctor_messages;

      if (this.dateRanges) {
        tmp = tmp.filter(m => {
          const currentDate = this.$moment(m.date, "DD/MM/YYYY HH:mm:ss");
          return currentDate.isBetween(
            this.dateRanges.startDate,
            this.dateRanges.endDate,
            "()"
          );
        });
      }

      if (this.selectedMsgType && this.selectedMsgType.length) {
        tmp = tmp.filter(m => this.selectedMsgType.includes(m.medium));
      }

      return tmp.sort((a, b) =>
        this.$moment(b.date, "DD/MM/YYYY HH:mm:ss").diff(
          this.$moment(a.date, "DD/MM/YYYY HH:mm:ss")
        )
      );
    },
    numberOfPages() {
      const float = this.messages.length / this.msgsPerPage;
      return Math.ceil(float);
    },
    displayedMsgs() {
      const isInvalidPage =
        this.numberOfPages <= this.currentPage || this.currentPage < 0;

      if (this.messages.length && isInvalidPage) this.setPage(1);

      const start = this.currentPage * this.msgsPerPage;
      const end = Math.min(start + this.msgsPerPage, this.messages.length);

      return this.messages.slice(start, end);
    },
    selectedMsgTypeForPopup() {
      return this.msgsTypeForPopup.filter(t =>
        this.selectedMsgType.includes(t.name)
      );
    }
  },
  data() {
    return {
      locale: LOCALE,
      dateRanges: {
        endDate: this.$moment().format("YYYY-MM-DDT00:00:00"),
        startDate: this.$moment()
          .subtract(1, "months")
          .format("YYYY-MM-DDT00:00:00")
      },
      defaultSelectedMsgType: ["email", "sms", "push"],
      selectedMsgType: ["email", "sms", "push"],
      msgsType: [
        { text: "SMS", value: "sms" },
        { text: "EMAIL", value: "email" },
        { text: "PUSH", value: "push" }
      ],
      msgsTypeForPopup: [
        { hebrewName: "SMS", name: "sms" },
        { hebrewName: "EMAIL", name: "email" },
        { hebrewName: "PUSH", name: "push" }
      ],
      msgsPerPage: 5,
      currentPage: 0
    };
  },
  methods: {
    getMsgType(value) {
      const found = this.msgsType.find(t => t.value === value);
      return found ? found.text : "";
    },
    updateDatesFromCalendar(values) {
      this.dateRanges = {
        startDate: this.$moment(values.startDate).format("YYYY-MM-DDT00:00:00"),
        endDate: this.$moment(values.endDate).format("YYYY-MM-DDT00:00:00")
      };
    },
    toggleSelectedType(value) {
      if (this.selectedMsgType.includes(value)) {
        this.selectedMsgType = this.selectedMsgType.filter(t => t !== value);
      } else {
        this.selectedMsgType.push(value);
      }
    },
    setPage(pageNumber) {
      this.currentPage = pageNumber - 1;
      window.location.hash = `&page=${pageNumber}`;
    },
    openFiltersPopup() {
      this.$modal.show(TableFiltersMobilePopup, {
        columns: this.msgsTypeForPopup,
        showenTableColumns: this.selectedMsgTypeForPopup,
        setShownedColumns: value => {
          this.selectedMsgType = value.map(v => v.name);
        }
      });
    }
  }
};
</script>
